/* eslint-disable max-len */
import { Form, Modal, Button } from 'antd';
// import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
// import { setPaymentInfo } from '@store';
// import { useDispatch } from 'react-redux';
import InfoTip from '@assets/info-tip.svg';
import classes from './ModalForm.module.css';
import { isEmail, isOnlyNumber, isValiate } from '../../../utils';

import DirectDeposit from './DirectDeposit';
import InstantTransfer from './InstantTransfer';
import PayPal from './PayPal';
import Venmo from './Venmo';
import {
  methodName, MODAL_TIPS, VENMO_ATTR,
} from '../const';

const FormFields = (title, fields) => {
  const map = {
    [methodName.DD]: <DirectDeposit fields={fields} />,
    [methodName.IT]: <InstantTransfer fields={fields} />,
    [methodName.PP]: <PayPal fields={fields} />,
    [methodName.VV]: <Venmo fields={fields} />,
  };
  return map[title];
};
export default function ModalForm({
  open, payment, setOpen, goToNextPage, loading,
}) {
  const [disabled, setDisabled] = useState(true);
  // const navigate = useNavigate();
  // const dispatch = useDispatch();
  const [form] = Form.useForm();

  // console.log(payment, 'payment');

  const onFinish = async (values) => {
    const {
      venmoAccountNumber,
    } = values;
    let accountValues = {};
    // 特殊处理venmo的字段，定义和接口不一致
    if (payment.attribute === VENMO_ATTR) {
      accountValues = {
        accountType: 'USER_HANDLE',
        accountNumber: venmoAccountNumber,
      };
    } else {
      accountValues = { ...values };
    }
    // await dispatch(setPaymentInfo({ [payment.attribute]: accountValues }));
    goToNextPage({ [payment.attribute]: accountValues });
  };

  const handleChange = (value, values) => {
    const {
      email, venmoType, routingNumber, accountNumber, venmoAccountNumber,
      // venmoEmail, phoneNumber,
    } = values;
    const requireValues = { ...values };
    delete requireValues.other_apartment; // because other_apartment is not required
    let flag = false;
    Object.values(requireValues).forEach((item) => {
      if (
        (venmoAccountNumber && !isValiate(venmoAccountNumber))
        // (venmoType === VENMO_TYPE_EMAIL && !venmoEmail) // venmoType==1 need venmoEmail
        // || (venmoType === VENMO_TYPE_EMAIL && venmoEmail && !isEmail(venmoEmail))
        // || (venmoType === VENMO_TYPE_PHONE && !phoneNumber) // venmoType==2 need phoneNumber
        // || (venmoType === VENMO_TYPE_PHONE && phoneNumber && !/^\d{10}$/.test(phoneNumber)) // venmoType==2 need phoneNumber
        || (!venmoType && !item) // all is required
        || (!venmoType && email && !isEmail(email)) // email must be valid
        || ((routingNumber && !isOnlyNumber(routingNumber)) || (routingNumber && routingNumber?.length !== 9))
        || (accountNumber && !isOnlyNumber(accountNumber))

      ) {
        flag = true;
      }
    });
    if (disabled !== flag) {
      setDisabled(flag);
    }
  };
  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
    setDisabled(true);
  };
  return (
    <Modal
      open={open}
      title="Add transfer method"
      width="620px"
      backText="Cancel"
      continueText="Continue"
      continueDisabled={disabled}
      onCancel={handleCancel}
      // destroyOnClose
      footer={false}
      bodyStyle={{
        overflow: 'auto', maxHeight: 600,
      }}
      className="payment_modal"
    >
      <div className={classes.modal_tips}>
        <img src={InfoTip} alt="" />

        <span>{MODAL_TIPS}</span>
      </div>
      <div className={classes.modal_method_name}>{payment.title}</div>

      <Form
        name="paymentForm"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className={classes.form}
        onValuesChange={handleChange}
        initialValues={{
          accountClass: 'PERSONAL',
          venmoType: 'email',
        }}
      >

        {FormFields(payment.title, payment.fields)}

        <div style={{ height: '60PX' }}></div>
        <div
          className={classes.modal_bottom}
        >
          <Button onClick={handleCancel}>
            Back
          </Button>
          <Button type="primary" htmlType="submit" disabled={disabled} loading={loading}>
            Continue
          </Button>
        </div>
      </Form>
    </Modal>

  );
}
